import { LabTest, SourceType } from '@/modules/surgicalEvent';

export const hasPatientsAppSourceType = (labTest: LabTest): boolean => {
  if (!('sourceTypeMap' in labTest) || !labTest.sourceTypeMap) {
    return false;
  }

  return Object.values(labTest.sourceTypeMap).some(
    (sourceType) => sourceType === SourceType.PATIENTS_APP
  );
};
